import { createSlice } from '@reduxjs/toolkit';
import { DEFAULT_FILTER } from 'src/app/leads/leads.constant';

const initialState = {
  ...DEFAULT_FILTER,
};

const filter = createSlice({
  name: 'filter',
  initialState,
  reducers: {
    setFilter: (_, { payload }) => ({ ...payload }),
    resetFilter: (_, { payload }) => ({ ...DEFAULT_FILTER, ...payload }),
  },
});

export const { setFilter, resetFilter } = filter.actions;
export default filter.reducer;
